// extracted by mini-css-extract-plugin
export default {"navbarLogo":"PublicLayout_navbarLogo__p5oFk","mainContainer":"PublicLayout_mainContainer__FqIIg"};